// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FunctionComponent } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
/* Starter Custom Code - End */

/** Store Custom Code - Start */
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
/** Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
    // Store Custom Code
    session: getSession(state),
});

export interface CartApproverMessageStyles {
    approvingText?: TypographyPresentationProps;
    approvingWrapper?: InjectableCss;
    // Starter Custom Code
    infosBox?: InfosBoxProps;
}

export const cartApproverMessageStyles: CartApproverMessageStyles = {
    infosBox: {},
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = cartApproverMessageStyles;
const CartApproverMessage = ({ cart, session /* Store Custom Code */ }: Props) => {
    /* Store Custom Code - Start */
    const isBuyer1 = session.userRoles?.toLowerCase().includes("buyer1");
    const approverName = cart?.properties?.approverName;

    if (cart && cart.isAwaitingApproval && !(cart.cartLines?.length === 0)) {
        return (
            <InfosBox {...styles.infosBox} data-test-selector="cart_approvingOrderMessage">
                {translate("You are approving order #{0}", cart.orderNumber)}
            </InfosBox>
        );
    }

    if (cart && isBuyer1 && approverName && !(cart.cartLines?.length === 0)) {
        return (
            <InfosBox {...styles.infosBox} data-test-selector="cart_buyer1OrderMessage">
                {translate("Your order will be approved by {0}.", approverName)}
            </InfosBox>
        );
    }

    return null;
    /* Store Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CartApproverMessage),
    definition: {
        displayName: "Cart Approver Message",
        icon: "cart-circle-check",
        group: "Common",
    },
};

export default widgetModule;
